import { render, staticRenderFns } from "./CcrisMainInfo.vue?vue&type=template&id=376c2f66"
import script from "./CcrisMainInfo.vue?vue&type=script&lang=js"
export * from "./CcrisMainInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports